
const state = {
  loading: false,
  authorizeLoading: false
}

const getters = {
  loading (state) {
    return state.loading
  },
  authorizeLoading (state) {
    return state.authorizeLoading
  }
}

const actions = {
  toggleLoading ({commit, dispatch}, paylaod) {
    commit('mutationLoading', paylaod)
  },
  toggleAuthLoading ({commit, dispatch}, paylaod) {
    commit('mutationAuthLoading', paylaod)
  },
  
}

const mutations = {
  mutationLoading (state, paylaod) {
    state.loading = paylaod
  },
  mutationAuthLoading (state, paylaod) {
    state.authorizeLoading = paylaod
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
